import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import collegeLogo from '../assets/images/logo_clg.webp';
import consentOfAffiliationPdf from '../assets/files/CONSENT-OF-AFFILIATION-GMC.pdf';
import collegeLopPdf from '../assets/files/mbbs-lop-letter.pdf';
import ugPgRequiredDocumentsPdf from '../assets/files/UG & PG Require doctm.pdf';
import stipendDetailsPdf from '../assets/files/2025HMF_MS129_E.pdf';
import boysHostelAdmissionPdf from '../assets/files/boys hostel admission.pdf';
import girlsHostelWardenFeePdf from '../assets/files/girls hostel warden and fee details.pdf';

function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  return (
    <header className="sticky-top">
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
        <div className="container">
          
          {/* Logo and Title */}
          <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeNav}>
            <img 
              src={collegeLogo} 
              alt="ACSR Logo" 
              height="50" 
              className="me-2"
              style={{ maxHeight: '50px', width: 'auto' }}
            />
            <div className="d-flex flex-column">
              <h1 className="fs-5 mb-0 fw-bold text-primary">A.C.S.R</h1>
              <p className="mb-0 fs-6 text-muted d-none d-sm-block">GOVERNMENT MEDICAL COLLEGE</p>
              <p className="mb-0 fs-6 text-muted d-block d-sm-none">GMC</p>
            </div>
          </Link>

          {/* Mobile Toggler */}
          <button 
            className="navbar-toggler border-0" 
            type="button" 
            onClick={toggleNav}
            aria-expanded={isNavOpen}
            aria-label="Toggle navigation"
          >
            <span className={`navbar-toggler-icon ${isNavOpen ? 'rotate' : ''}`}></span>
          </button>

          {/* Navigation Menu */}
          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
            {/* Mobile Close Button */}
            <div className="d-lg-none d-flex justify-content-end mb-3">
              <button 
                className="btn-close" 
                type="button" 
                onClick={closeNav}
                aria-label="Close navigation"
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  color: '#6c757d',
                  cursor: 'pointer',
                  padding: '0.5rem'
                }}
              >
                ✕
              </button>
            </div>
            
            <ul className="navbar-nav ms-auto">
              
              {/* About Us */}
              <li className="nav-item">
                <Link className="nav-link px-3" to="/about" onClick={closeNav}>
                  About Us
                </Link>
              </li>

              {/* Departments Dropdown */}
              <li className="nav-item dropdown">
                <span 
                  className="nav-link dropdown-toggle px-3" 
                  role="button" 
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Departments
                </span>
                <ul className="dropdown-menu dropdown-menu-end">
                  {[
                    'anaesthesiology', 'anatomy', 'biochemistry', 'cardiology', 'community-medicine', 'dentistry', 'dermatology', 'dvl',
                    'forensic-medicine', 'emergency-medicine', 'ent', 'general-medicine', 'general-surgery',
                    'hospital-administration', 'mch-neuro-surgery', 'mch-surgical-oncology', 'ophthalmology',
                    'microbiology', 'neurology', 'obstetrics-gynaecology', 'orthopedics', 'paediatrics',
                    'pathology', 'pharmacology', 'physiology', 'psychiatry', 'pulmonary-medicine',
                    'radio-diagnosis', 'radiation-oncology', 'transfusion-medicine', 'urology'
                  ].map((dept) => (
                    <li key={dept}>
                      <Link 
                        className="dropdown-item" 
                        to={`/departments/${dept}`}
                        onClick={closeNav}
                      >
                        {dept.replace(/-/g, ' ').toUpperCase()}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>

              {/* Govt Approvals Dropdown */}
              <li className="nav-item dropdown">
                <span 
                  className="nav-link dropdown-toggle px-3" 
                  role="button" 
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Govt Approvals
                </span>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <a
                      className="dropdown-item"
                      href={consentOfAffiliationPdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeNav}
                    >
                      Consent of Affiliation
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={collegeLopPdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeNav}
                    >
                      College lop
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={ugPgRequiredDocumentsPdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeNav}
                    >
                      UG & PG Admission required documents
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={stipendDetailsPdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeNav}
                    >
                      PG degree & House surgeons stipend details
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={boysHostelAdmissionPdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeNav}
                    >
                      Boys Hostel Admission
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={girlsHostelWardenFeePdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeNav}
                    >
                      Girls Hostel Warden & Fee Details
                    </a>
                  </li>
                  <li>
                    <a 
                      className="dropdown-item" 
                      href="https://acsrgmc.nmcindia.ac.in/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      onClick={closeNav}
                    >
                      NMC India Attendance ↗
                    </a>
                  </li>
                </ul>
              </li>

              {/* NIRF */}
              <li className="nav-item">
                <Link className="nav-link px-3" to="/nirf-2025" onClick={closeNav}>
                  NIRF
                </Link>
              </li>

              {/* Committees */}
              <li className="nav-item">
                <Link className="nav-link px-3" to="/committees" onClick={closeNav}>
                  Committees
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>

      {/* Mobile Overlay */}
      {isNavOpen && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
          style={{ zIndex: 1040 }}
          onClick={closeNav}
        ></div>
      )}

      <style jsx>{`
        .navbar-toggler-icon.rotate {
          transform: rotate(90deg);
          transition: transform 0.3s ease;
        }
        
        .navbar-toggler-icon {
          transition: transform 0.3s ease;
        }
        
        @media (max-width: 991.98px) {
          .navbar-collapse {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            background: white;
            z-index: 1050;
            padding: 2rem;
            overflow-y: auto;
          }
          
          .navbar-nav {
            margin-top: 2rem;
          }
          
          .nav-item {
            margin-bottom: 1rem;
          }
          
          .nav-link {
            font-size: 1.1rem;
            padding: 0.75rem 0 !important;
            border-bottom: 1px solid #eee;
          }
          
          .dropdown-menu {
            border: none;
            box-shadow: none;
            background: transparent;
            padding-left: 1rem;
          }
          
          .dropdown-item {
            padding: 0.5rem 0;
            color: #6c757d;
          }
          
          .dropdown-item:hover {
            background: transparent;
            color: #007bff;
          }
        }
        
        @media (min-width: 992px) {
          .navbar-nav .nav-link {
            position: relative;
          }
          
          .navbar-nav .nav-link::after {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: 0;
            left: 50%;
            background-color: #007bff;
            transition: all 0.3s ease;
            transform: translateX(-50%);
          }
          
          .navbar-nav .nav-link:hover::after {
            width: 100%;
          }
        }
      `}</style>
    </header>
  );
}

export default Header;
